import { keyframes } from 'react-emotion'

export const fadeIn = keyframes({
  '0%': { opacity: 0, },
  '100%': { opacity: 1, },
})

export const fadeOut = keyframes({
  '0%': { opacity: 1, },
  '100%': { opacity: 0, },
})

export const fadeRight = keyframes({
  '0%': { opacity: 0, transform: 'translateX(20px)' },
  '100%': { opacity: 1, transform: 'translateX(0px)' },
})

export const fadeLeft = keyframes({
  '0%': { opacity: 0, transform: 'translateX(-20px)' },
  '100%': { opacity: 1, transform: 'translateX(0px)' },
})

export const fadeUp = keyframes({
  '0%': { opacity: 0, transform: 'translateY(20px)' },
  '100%': { opacity: 1, transform: 'translateY(0px)' },
})

export const fadeDown = keyframes({
  '0%': { opacity: 0, transform: 'translateY(-20px)' },
  '100%': { opacity: 1, transform: 'translateY(0px)' },
})

export const fadeZoom = keyframes({
  '0%': { opacity: 0, transform: 'scale(0.8)' },
  '100%': { opacity: 1, transform: 'scale(1)' },
})

export const spin = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
})

export const flip2 = keyframes({
  '0%': { transform: 'rotateY(0deg)' },
  '30%': { transform: 'rotateY(180deg)' },
  '50%': { transform: 'rotateY(180deg)' },
  '80%': { transform: 'rotateY(360deg)' },
  '100%': { transform: 'rotateY(360deg)' },
})

export const flip = keyframes({
  '0%': { transform: 'rotateY(0deg)' },
  '10%': { transform: 'rotateY(0deg)' },
  '50%': { transform: 'rotateY(180deg)' },
  '100%': { transform: 'rotateY(360deg)' },
})

export const flip3 = keyframes({
  '0%': { transform: 'rotateY(0deg)' },
  '5%': { transform: 'rotateY(0deg)' },
  '30%': { transform: 'rotateY(180deg)' },
  '50%': { transform: 'rotateY(360deg)' },
  '55%': { transform: 'rotateX(0deg)' },
  '80%': { transform: 'rotateX(180deg)' },
  '100%': { transform: 'rotateX(360deg)' },
})



// WEBPACK FOOTER //
// ./src/styles/animations.js